import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  runInPlaceRestore(vdcId, vappId, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapp/' + vappId + '/restore';
    return this.http
      .post(url, JSON.stringify(obj))
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/in-place-restore/in-place-restore.service.ts